import { render, staticRenderFns } from "./card-M.vue?vue&type=template&id=68668c67&scoped=true&"
import script from "./card-M.vue?vue&type=script&lang=js&"
export * from "./card-M.vue?vue&type=script&lang=js&"
import style0 from "./card-M.vue?vue&type=style&index=0&id=68668c67&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68668c67",
  null
  
)

export default component.exports